/* ===== CURSOR ===== */
const cursor = document.getElementById('cursor');
const ring   = document.getElementById('cursor-ring');

if (cursor && ring && window.innerWidth > 768) {
  let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

  document.addEventListener('mousemove', e => {
    mouseX = e.clientX; mouseY = e.clientY;
    cursor.style.left = mouseX + 'px';
    cursor.style.top  = mouseY + 'px';
  });

  (function animateRing() {
    ringX += (mouseX - ringX) * 0.12;
    ringY += (mouseY - ringY) * 0.12;
    ring.style.left = ringX + 'px';
    ring.style.top  = ringY + 'px';
    requestAnimationFrame(animateRing);
  })();

  document.querySelectorAll('a, button, .product-card, .collection-card, .insta-item').forEach(el => {
    el.addEventListener('mouseenter', () => {
      cursor.style.width = '16px'; cursor.style.height = '16px';
      cursor.style.background = '#FFE000';
      ring.style.transform = 'translate(-50%, -50%) scaleX(1.4) scale(1.15)';
    });
    el.addEventListener('mouseleave', () => {
      cursor.style.width = '14px'; cursor.style.height = '14px';
      cursor.style.background = '#FFE000';
      ring.style.transform = 'translate(-50%, -50%) scaleX(1.4)';
    });
  });
}

/* ===== NAV SCROLL + BANDEAU RÉTRACTABLE ===== */
const navbar          = document.querySelector('.site-nav');
const announcementBar = document.querySelector('.announcement-bar');

if (navbar) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 60;
    navbar.classList.toggle('scrolled', scrolled);
    if (announcementBar) {
      announcementBar.classList.toggle('hidden', scrolled);
    }
  });
}

/* ===== REVEAL ON SCROLL ===== */
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(el => observer.observe(el));
}

/* ===== CART DRAWER ===== */
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-overlay');
const cartBtns    = document.querySelectorAll('[data-open-cart]');
const cartClose   = document.getElementById('cart-close');

function openCart()  {
  if (cartDrawer)  cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  loadCart();
}
function closeCart() {
  if (cartDrawer)  cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
}

cartBtns.forEach(btn => btn.addEventListener('click', openCart));
if (cartClose)   cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

/* Fetch & render cart */
async function loadCart() {
  const cartContent = document.getElementById('cart-content');
  if (!cartContent) return;
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.item_count === 0) {
      cartContent.innerHTML = '<div class="cart-empty">Votre panier est vide.<br><br><a href="/collections/all" class="btn-primary" style="display:inline-flex">Voir la boutique →</a></div>';
    } else {
      cartContent.innerHTML = cart.items.map(item => `
        <div style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid rgba(0,0,0,0.07);">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" style="width:80px;height:100px;object-fit:cover;border-radius:6px;flex-shrink:0;">` : `<div style="width:80px;height:100px;border-radius:6px;background:#f0e8e0;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:0.7rem;color:#999;">WEMA</div>`}
          <div style="flex:1">
            <div style="font-family:var(--serif);font-size:0.95rem;font-weight:700;margin-bottom:0.25rem">${item.product_title}</div>
            <div style="font-size:0.75rem;color:var(--muted);margin-bottom:0.5rem">${item.variant_title || ''}</div>
            <div style="display:flex;justify-content:space-between;align-items:center">
              <div style="font-size:0.9rem;font-weight:500;color:var(--coral-dark)">${formatMoney(item.final_price)}</div>
              <div style="display:flex;align-items:center;gap:0.75rem;">
                <span style="font-size:0.82rem;color:var(--muted);">Qté : ${item.quantity}</span>
                <button onclick="updateQty('${item.key}', 0)" style="font-size:0.7rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;background:none;border:none;cursor:pointer;text-decoration:underline;">Supprimer</button>
              </div>
            </div>
          </div>
        </div>
      `).join('') + `
        <div style="margin-top:1.5rem">
          <div style="display:flex;justify-content:space-between;font-family:var(--serif);font-size:1.1rem;font-weight:700;margin-bottom:1.5rem">
            <span>Total</span><span style="color:var(--coral-dark)">${formatMoney(cart.total_price)}</span>
          </div>
          <a href="/checkout" class="btn-primary" style="width:100%;justify-content:center;border-radius:100px">Passer commande →</a>
          <a href="/cart" style="display:block;text-align:center;margin-top:0.75rem;font-size:0.75rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase">Voir le panier</a>
        </div>
      `;
    }
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
  } catch(e) { console.error(e); }
}

async function updateQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  loadCart();
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

/* ===== ADD TO CART ===== */
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', async function() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    this.textContent = 'Ajout en cours…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      this.textContent = '✓ Ajouté !';
      openCart();
      setTimeout(() => { this.textContent = 'Ajouter au panier'; }, 2000);
    } catch(e) {
      this.textContent = 'Erreur, réessayez';
    }
  });
});

/* ===== WISHLIST (localStorage) ===== */
document.querySelectorAll('.product-card__wishlist').forEach(btn => {
  const productId = btn.dataset.productId;
  const wishlist  = JSON.parse(localStorage.getItem('wishlist') || '[]');
  if (wishlist.includes(productId)) { btn.textContent = '♥'; btn.style.color = 'var(--pink-dark)'; }
  btn.addEventListener('click', function() {
    const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const idx  = list.indexOf(productId);
    if (idx > -1) { list.splice(idx, 1); this.textContent = '♡'; this.style.color = ''; }
    else          { list.push(productId); this.textContent = '♥'; this.style.color = 'var(--pink-dark)'; }
    localStorage.setItem('wishlist', JSON.stringify(list));
  });
});

/* ===== NEWSLETTER ===== */
const nlForm = document.querySelector('.nl-form');
if (nlForm) {
  nlForm.addEventListener('submit', e => {
    e.preventDefault();
    const btn   = nlForm.querySelector('.nl-btn');
    const input = nlForm.querySelector('.nl-input');
    btn.textContent = '✓ Inscrit·e !';
    btn.style.background = 'var(--lime)';
    input.value = '';
    setTimeout(() => { btn.textContent = "S'abonner"; btn.style.background = ''; }, 3000);
  });
}

/* ===== FILTER PRODUCTS (collection page) ===== */
window.filterProducts = function(btn, tag) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.product-card').forEach(card => {
    card.style.display = (tag === 'all' || card.dataset.tags?.includes(tag)) ? '' : 'none';
  });
};

/* ===== MENU HAMBURGER ===== */
const hamburger     = document.getElementById('nav-hamburger');
const mobileMenu    = document.getElementById('mobile-menu');
const mobileOverlay = document.getElementById('mobile-menu-overlay');

if (hamburger) {
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    mobileOverlay.classList.toggle('open');
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });
  mobileOverlay.addEventListener('click', () => {
    hamburger.classList.remove('open');
    mobileMenu.classList.remove('open');
    mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  });
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('open');
      mobileOverlay.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}
/* ===== LIEN ACTIF DANS LE MENU ===== */
const currentPath = window.location.pathname;
document.querySelectorAll('.nav-links a').forEach(link => {
  const linkPath = new URL(link.href).pathname;
  if (currentPath === linkPath || 
     (linkPath !== '/' && currentPath.startsWith(linkPath))) {
    link.classList.add('active');
  }
});
/* ===== MENU ÉTOILE MOBILE ===== */
function toggleStarMenu() {
  const dropdown = document.getElementById('star-dropdown');
  dropdown.classList.toggle('open');
}

document.addEventListener('click', function(e) {
  const menu = document.querySelector('.nav-star-menu');
  if (menu && !menu.contains(e.target)) {
    document.getElementById('star-dropdown').classList.remove('open');
  }
});